var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoOrcid = function SvgLogoOrcid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 256 256"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".logo-orcid_svg__st1{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    d: "M256 128c0 70.7-57.3 128-128 128S0 198.7 0 128 57.3 0 128 0s128 57.3 128 128",
    style: {
      fill: "#a6ce39"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.3 186.2H70.9V79.1h15.4v107.1M108.9 79.1h41.6c39.6 0 57 28.3 57 53.6 0 27.5-21.5 53.6-56.8 53.6h-41.8zm15.4 93.3h24.5c34.9 0 42.9-26.5 42.9-39.7C191.7 111.2 178 93 148 93h-23.7zM88.7 56.8c0 5.5-4.5 10.1-10.1 10.1s-10.1-4.6-10.1-10.1c0-5.6 4.5-10.1 10.1-10.1s10.1 4.6 10.1 10.1",
    className: "logo-orcid_svg__st1"
  })));
};
export default SvgLogoOrcid;